import { AbstractControl } from "@angular/forms";

export function leafNodeValidator(control: AbstractControl) {
    
    const isLeafAccountValue = control?.value;
    return isLeafAccountValue ? null : {isLeafNode: true};
}